import React from "react";
import styled from "styled-components";

const ProseContainer = styled.div`
	line-height: 1.41;

	h1,
	h2,
	h3,
	h4,
	p {
		max-width: 50rem;
	}
`;

const Prose = (props: any) => {
	return <ProseContainer>{props.children}</ProseContainer>;
};
export default Prose;
